import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import {
  StyledSwiperContainer,
  ScoreSlide,
  ScoreText,
  TeamLogo,
  ScoreTeams,
  TextMatchDate,
  TeamInfo,
} from "./CarouselTeamsHistoric.style";

interface MatchResult {
  matchDate: string;
  homeTeamLogo: string;
  homeTeamName: string;
  homeTeamScore: number;
  awayTeamLogo: string;
  awayTeamName: string;
  awayTeamScore: number;
}

interface CarouselTeamsHistoricProps {
  scores: MatchResult[];
}

export default function CarouselTeamsHistoric({ scores }: CarouselTeamsHistoricProps) {
  return (
    <StyledSwiperContainer>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        navigation
        slidesPerView={1} // Padrão para mobile
        breakpoints={{
          640: { slidesPerView: 2 }, // 2 cards em telas menores
          1024: { slidesPerView: 3 }, // 3 cards em telas médias
          1440: { slidesPerView: 4 }, // 4 cards em desktops grandes
          1920: { slidesPerView: 5 }, // 5 cards para telas ultra-wide
        }}
      >
        {scores.map((result: MatchResult, index: number) => (
          <SwiperSlide key={index}>
            <ScoreSlide>
              <TextMatchDate>
                <p>{result.matchDate}</p>
              </TextMatchDate>

              <ScoreTeams>
                <TeamInfo>
                  <TeamLogo src={result.homeTeamLogo} alt="Home Team Logo" />
                  <p>{result.homeTeamName}</p>
                  <b>Casa</b>
                </TeamInfo>
                <ScoreText>
                  {result.homeTeamScore} x {result.awayTeamScore}
                </ScoreText>
                <TeamInfo>
                  <TeamLogo src={result.awayTeamLogo} alt="Away Team Logo" />
                  <p>{result.awayTeamName}</p>
                  <b>Fora</b>
                </TeamInfo>
              </ScoreTeams>
            </ScoreSlide>
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledSwiperContainer>
  );
}
